import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { EstimateContainer } from '../../common/components/redesignComponents/common/Redesign.styles';
import AncillariAutoModalButtons from './components/AncillariAutoModalButtons';
import AncillariAutoModal from './components/AncillariAutoModal';
import ErrorComponent from '../../common/components/ErrorComponent';
import { confirmAlert, generalAlertError } from '../../common/utils/alerts';
import {
  AncillariAutoQuotesStyles,
  RiskContainer,
} from './styles/AncillariAutoResultPage.styles';
import {
  addAncillariAutoQuoteToCart,
  ancillariAutoQuotesGetQuotes,
  removeAncillariAutoQuoteFromCart,
  silentLoadAncillariQuotes,
} from '../../features/insuranceRequests/insuranceRequestsActions';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import { AvvisoAlert } from '../RcQuotes.styles';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';
import { primaQuoteTypes } from '../../common/constants';
import { V2FontImport } from '../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import AncillariAutoSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/AncillariAutoSummaryCard';
import QuoteCostSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  OutlineActionButton,
  ActionButtonBadge,
} from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
import FailedQuotationsComponent from '../../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

function AncillariAutoResultPage() {
  const { requestToken } = useParams();
  const navigate = useNavigate();
  const {
    loading,
    error,
    insuranceRequest,
    customer,
    quotations,
    addingQuote,
    processingQuote,
    riskQuotations,
    failedQuotes,
    vehicle,
    thread,
    est_provvigioni,
  } = useSelector((store) => store.insuranceRequests.ancillari_auto_quotes);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const refresh = () => ancillariAutoQuotesGetQuotes(requestToken);

  const silentRefresh = () => silentLoadAncillariQuotes(requestToken);

  const modifyData = () => {
    navigate('/quote/ancillari-auto', {
      state: { requestToken },
    });
  };

  const selectQuotation = (quoteId, closeButton) => {
    const quote = insuranceRequest ? insuranceRequest?.quotations?.find((q) => q.id === quoteId) : null;
    if (
      quote
      && quote.payment_frequency != insuranceRequest.payment_frequency
      && quote.quote_type === 'res_civile'
    ) {
      confirmAlert(
        `La frequenza di pagamento di questa quotazione è ${quote.payment_frequency == 1 ? 'annuale' : 'semestrale'}, mentre la frequenza di pagamento selezionata nella richiesta è ${insuranceRequest.payment_frequency == 1 ? 'annuale' : 'semestrale'}. Sei sicuro di voler aggiungere questa quotazione al carrello? Questo aggiornerà anche la frequenza di pagamento della richiesta.`,
        () => addAncillariAutoQuoteToCart(quoteId, refresh, modifyData, closeButton),
      );
    } else {
      confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addAncillariAutoQuoteToCart(quoteId, refresh, modifyData, closeButton));
    }
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeAncillariAutoQuoteFromCart(quoteId, refresh, modifyData));
  };

  useEffect(() => {
    ancillariAutoQuotesGetQuotes(requestToken);
  }, [requestToken]);

  const handleRequestPurchase = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    navigate(`/quotes/ancillari-auto/purchase/${requestToken}`);
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  // useEffect(() => {
  //   if (
  //     loading === false
  //     && insuranceRequest.is_expired === true
  //     && insuranceRequest.request_token === requestToken
  //   ) {
  //     navigate('/quote/ancillari-auto', {
  //       state: { requestToken: insuranceRequest.request_token },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [loading, insuranceRequest, requestToken]);

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }
  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_auto_result"
        />
      )}

      <V2FontImport />
      <AncillariAutoQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <AncillariAutoSummaryCard
              customer={customer}
              insuranceRequest={insuranceRequest}
              modificaDati={modifyData}
              vehicle={vehicle}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestPurchase()}
              rcTypeLabel={processingQuote?.product_name}
              est_provvigioni={est_provvigioni}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12 ">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end ">
                  <div>
                    <OutlineActionButton
                      type="button"
                      onClick={() => {
                        setShowConversationModal(true);
                        if (thread?.unreadMessages > 0) silentRefresh();
                      }}
                    >
                      <ChatIcon />
                      Contatta il Backoffice
                      {thread?.unreadMessages > 0 && (
                        <ActionButtonBadge>
                          {thread.unreadMessages}
                          <span className="visually-hidden">messaggi non letti</span>
                        </ActionButtonBadge>
                      )}
                    </OutlineActionButton>
                    {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                      <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                        <button className="btn btn-success px-2 py-1">Tutorial</button>
                      </div>
                    )} */}
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div>

          {quotations && !quotations.res_civile
            && (
              <AvvisoAlert role="alert">
                <h4>Avviso!</h4>
                <p>Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </AvvisoAlert>
            )}
          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => (
                    <React.Fragment key={index}>
                      {quotations && quotations[type.id] && (
                        <AncillariAutoModalButtons
                          insuranceRequest={insuranceRequest}
                          processingQuote={processingQuote}
                          type={type}
                          removeItemFromCart={removeItemFromCart}
                          riskQuotations={riskQuotations}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </RiskContainer>
                {quoteTypes.map((type, index) => (
                  <AncillariAutoModal
                    insuranceRequest={insuranceRequest}
                    type={type}
                    key={index}
                    addingQuote={addingQuote}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                    processingQuote={processingQuote}
                  />
                ))}
              </>
            )}
        </div>

        {failedQuotes !== null && failedQuotes.length > 0 && (
          <FailedQuotationsComponent failedQuotes={failedQuotes} />
        )}
      </AncillariAutoQuotesStyles>
    </>
  );
}

export default AncillariAutoResultPage;
